/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unescaped-entities */
import * as _ from 'lodash';
import { Badge, Button, Col, Collapse, Row, Table } from 'reactstrap';
import { IClaim, IncomingSidePanelProps } from '../typings';
import { acceptIncomingClaim, cancelClaim, rejectIncomingClaim, slaDoneMessageCheck, uploadFile } from '../../../actions/update-claim';
import { alertTriangle, check, chevronDown, chevronUp, loader, x } from 'react-icons-kit/feather';
import { connect } from 'react-redux';
import { ensureGlassPositionOptions } from '../../../helpers/utils';
import { toast } from 'react-toastify';
import CancelModal from '../../modals/CancelModal';
import ClaimInfoEdit from '../shared/ClaimInfoEdit';
import Icon from 'react-icons-kit';
import IncomingTodo from './todo/IncomingTodo';
import NotesComponent from '../shared/Notes';
import React, { ReactElement, useState } from 'react';
import moment from 'moment';

const initialState: { cancelling: boolean; accepting: boolean } = {
  cancelling: false,
  accepting: false,
};

const IncomingSidePanel: React.FC<IncomingSidePanelProps> = ({
  claim,
  todos,
  partner,
  onClose,
  uploadFile,
  acceptIncomingClaim,
  rejectIncomingClaim,
  cancelClaim,
  slaDoneMessageCheck,
}) => {
  const [state, setState] = useState(initialState);
  const [modalOpen, setModalOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [editOpen, setEditOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(true);
  const [loadingCheck, setLoadingCheck] = useState(false);

  const collapseConfig = { show: 100, hide: 100 };

  const cancel = (e: any) => {
    if (!claim) {
      return false;
    }
    setState({ ...state, cancelling: true });
    cancelClaim(claim.id, reason, 'destination', (err: Error) => {
      setState({ ...state, cancelling: false });
      if (err) {
        console.error(err);
        toast.error('Could not reject claim, please try again later.');
        return;
      }
      onClose(e);
    });
  };

  const confirmCancel = () => {
    setModalOpen(false);
    cancel(false);
  };

  const rejectCancel = () => {
    setModalOpen(false);
  };

  const showModal = () => {
    setModalOpen(true);
  };

  const acceptClaim = (e: any) => {
    if (!claim) {
      return;
    }
    setState({ ...state, accepting: true });
    acceptIncomingClaim(claim.id, (err: Error) => {
      setState({ ...state, accepting: false });
      if (err) {
        console.error(err);
        toast.error('Could not accept claim, please try again later.');
        return;
      }
    });
  };

  const slaDoneCheck = () => {
    if (!claim) {
      return;
    }
    setLoadingCheck(true);
    slaDoneMessageCheck(claim.id, (err: Error) => {
      setLoadingCheck(false);
      if (err) {
        console.error(err);
        toast.error('Could not update SLA check, please try again later.');
      }
    });
  };

  const determineCurrentStep = () => {
    if (!todos || !claim) {
      return null;
    }
    let currentTodo = _.first(todos);
    try {
      _.each(todos, (todo, index) => {
        const isNext =
          (claim.todos[todo?.key] ? claim.todos[todo?.key].completed === false : false) ||
          _.isUndefined(claim.todos[todo?.key]);
        if (isNext) {
          currentTodo = todos[Number(index)];
          return false;
        }
        return true;
      });
    } catch (e) {
      console.error(e);
    }
    return currentTodo;
  };

  const disableCancelButton = (): boolean => {
    const currentStep = determineCurrentStep();
    return currentStep?.allowCancel === false;
  };

  const disableButtons = (): boolean => {
    return state.accepting || state.cancelling;
  };

  const onChangeReason = (value: string) => {
    setReason(value);
  };

  const renderClaim = (claim: IClaim): ReactElement | false => {
    const template = ensureGlassPositionOptions(partner.claimTemplate.claims);
    if (!claim) {
      return false;
    }

    const createdAt =
      claim?._audit?.created?.timestamp && !_.isDate(claim._audit.created.timestamp)
        ? claim._audit.created.timestamp.toDate()
        : null;
    const openedDays = createdAt ? Math.max(moment().diff(moment(createdAt), 'days'), 0) : null;

    return (
      <div className="claim-detail-modal incoming-claim-detail">
        <div className="header-panel claim-detail-header">
          <Button className="close-btn" onClick={(e) => onClose(e)}>
            <Icon icon={x} size={28} />
          </Button>
          <div className="claim-detail-hero">
            <div className="claim-detail-heading">
              <h2>
                <span>{claim?.insurer?.claimNumber}</span>
                <Badge className="status-badge">{claim?.status}</Badge>
              </h2>
              <div className="claim-detail-subtitle">
                {openedDays === null ? 'Opened recently' : `Opened ${openedDays} Days Ago`}
              </div>
            </div>
            <div className="claim-detail-alerts">
              {!claim?.assign?.owners?.partner ? (
                <div className="info-div">
                  <Icon icon={alertTriangle} tag="div" className="info-icon" />
                  <div>Please Accept or Reject to continue</div>
                </div>
              ) : null}
              {claim?.status !== 'NEW' &&
              claim?.sla.slaDoneMessage === false &&
              moment(new Date()).isAfter(
                moment(claim._audit.created.timestamp.toDate()).add(72, 'hours'),
              ) ? (
                <div className="info-div">
                  <Icon icon={alertTriangle} tag="div" className="info-icon" />
                  <div className="small-font">
                    It's been 72 hours since the claim has been logged, please drop a note about the
                    progress of the claim.
                  </div>
                  {!loadingCheck ? (
                    <button className="claim-alert-action" onClick={slaDoneCheck}>
                      <Icon icon={check} size={18} />
                    </button>
                  ) : (
                    <Icon icon={loader} size={18} className="spin ml-10" />
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <Row className="claim claim-detail-content">
          <Col sm={6} className="todo-list-container claim-detail-left">
            <div className="static">
              <IncomingTodo
                isDisabled={!claim?.assign?.owners?.partner}
                key="incoming-todo"
                claim={claim}
                todos={todos}
              />
            </div>
            <div className="edit-buttons claim-action-buttons">
              {!disableCancelButton() ? (
                <Button outline size="sm" onClick={showModal} disabled={disableCancelButton()}>
                  {state.cancelling ? 'Rejecting...' : 'Reject Claim'}
                </Button>
              ) : null}
              {!claim?.assign?.owners?.partner ? (
                <Button size="sm" block onClick={acceptClaim} disabled={disableButtons()}>
                  {state.accepting ? 'Accepting...' : 'Accept Claim'}
                </Button>
              ) : null}
            </div>
          </Col>
          <Col sm={6} className="claim-detail-right">
            <div className="panel-section">
              <Button
                className="accordion-btn"
                outline={editOpen ? false : true}
                size="sm"
                onClick={() => {
                  setEditOpen(!editOpen);
                  setChatOpen(!chatOpen);
                }}>
                <div>
                  Claim Information <Icon icon={editOpen ? chevronUp : chevronDown} size={20} />{' '}
                </div>
              </Button>
              <Collapse delay={collapseConfig} className="edit-info-collapse" isOpen={editOpen}>
                <ClaimInfoEdit
                  isCurrencyDisabled={true}
                  queue="destination"
                  groups={template}
                  claim={claim}
                  isDisabled={!claim?.assign?.owners?.partner}
                />
                <div className="sidebar-info-scrollbar">
                  <div className="claim-group">
                    <div className="claim-group-lebal" style={{ fontSize: '1.20em', fontWeight: 'bold', margin: '0px 0px 0px 10px'}}>
                      <div>Claim Originator</div>
                    </div>
                    <Table className="sidepanel-info-table table table-borderless">
                      <colgroup>
                        <col width="30%" />
                        <col width="70%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>Created By</td>
                          <td>
                            <div className="form-group">
                              <div>{claim?.assign?.origin}</div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="panel-section notes-panel">
              <Button
                className="accordion-btn"
                outline={chatOpen ? false : true}
                size="sm"
                onClick={() => {
                  setChatOpen(!chatOpen);
                  setEditOpen(!editOpen);
                }}>
                <div>
                  Claim Notes <Icon icon={chatOpen ? chevronUp : chevronDown} size={20} />{' '}
                </div>
              </Button>
              <Collapse delay={collapseConfig} isOpen={chatOpen}>
                <div className="static">
                  <NotesComponent claim={claim} />
                </div>
              </Collapse>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  if (!claim) {
    return <div></div>;
  }

  return (
    <div>
      <CancelModal
        claim={claim}
        onConfirm={confirmCancel}
        onCancel={rejectCancel}
        isOpen={modalOpen}
        reason={reason}
        onChangeReason={onChangeReason}
      />
      <div className={`side-panel-overlay ${claim ? 'open' : ''}`}></div>
      <div id="incoming-side-panel" className={`side-panel ${claim ? 'open' : ''}`}>
        {claim ? renderClaim(claim) : false}
      </div>
    </div>
  );
};

export default connect(null, {
  acceptIncomingClaim,
  rejectIncomingClaim,
  slaDoneMessageCheck,
  uploadFile,
  cancelClaim,
})(IncomingSidePanel);
